// FICHIER : frontend/src/pages/Candidature.jsx
import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import NavLogo from '../components/NavLogo';
import axios from 'axios';

const API = 'https://ark-recruitment-backend.onrender.com/api';

const IconArrow = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 12h14M12 5l7 7-7 7"/>
  </svg>
);

const OFFRE = {
  ref:     'TOS-DEV-001',
  titre:   'Développeur Full Stack',
  salaire: '800k – 1,5M FCFA/mois',
  stack:   ['React','Node.js','TypeScript','PostgreSQL','GraphQL','Docker'],
  responsabilites: [
    "Développer et maintenir les interfaces React et APIs Node.js.",
    "Concevoir et optimiser les bases de données PostgreSQL.",
    "Intégrer des services tiers et APIs d'intelligence artificielle.",
    "Participer aux revues de code et garantir la qualité.",
    "Déployer et monitorer les applications sur les environnements cloud.",
  ],
  profil: [
    "3+ années d'expérience en développement Full Stack.",
    "Maîtrise de TypeScript, REST APIs, GraphQL.",
    "Expérience Git, CI/CD, Docker et déploiement cloud.",
    "Autonomie en environnement 100% distant.",
  ],
};

const INDICATIFS = [
  { code:'+242', pays:'Congo (Brazzaville)' },
  { code:'+243', pays:'Congo (Kinshasa)' },
  { code:'+237', pays:'Cameroun' },
  { code:'+225', pays:"Côte d'Ivoire" },
  { code:'+221', pays:'Sénégal' },
  { code:'+241', pays:'Gabon' },
  { code:'+33',  pays:'France' },
  { code:'+1',   pays:'USA/Canada' },
  { code:'+44',  pays:'Royaume-Uni' },
];

const LETTRES_REGEX  = /[^A-Za-zÀ-ÿ\s-]/g;
const TEL_REGEX      = /[^0-9\s]/g;
const EMAIL_REGEX    = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const LINKEDIN_REGEX = /^https:\/\/(www\.)?linkedin\.com\/in\/.+/;
const NOM_VALID      = /^[A-Za-zÀ-ÿ\s-]+$/;
const TEL_VALID      = /^[0-9\s]{6,15}$/;

export default function Candidature() {
  const navigate = useNavigate();
  const location = useLocation();
  const offre = location.state?.offre || OFFRE;
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const h = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', h);
    return () => window.removeEventListener('resize', h);
  }, []);

  const [errors,    setErrors]    = useState({});
  const [prenom,    setPrenom]    = useState('');
  const [nom,       setNom]       = useState('');
  const [email,     setEmail]     = useState('');
  const [indicatif, setIndicatif] = useState('+242');
  const [tel,       setTel]       = useState('');
  const [linkedin,  setLinkedin]  = useState('');

  const validate = () => {
    const e = {};
    if (!prenom.trim())                e.prenom   = 'Champ obligatoire';
    else if (!NOM_VALID.test(prenom))  e.prenom   = 'Lettres uniquement';
    if (!nom.trim())                   e.nom      = 'Champ obligatoire';
    else if (!NOM_VALID.test(nom))     e.nom      = 'Lettres uniquement';
    if (!email.trim())                 e.email    = 'Champ obligatoire';
    else if (!EMAIL_REGEX.test(email)) e.email    = 'Format invalide (ex: nom@email.com)';
    if (!tel.trim())                   e.tel      = 'Champ obligatoire';
    else if (!TEL_VALID.test(tel))     e.tel      = 'Chiffres uniquement (6 à 15 chiffres)';
    if (linkedin.trim() && !LINKEDIN_REGEX.test(linkedin))
      e.linkedin = 'Format invalide (ex: https://linkedin.com/in/votre-profil)';
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    try {
      await axios.post(`${API}/candidature`, {
        offre_id: offre.id && !String(offre.id).startsWith('demo') ? offre.id : null,
        prenom: prenom.trim(),
        nom: nom.trim(),
        email: email.trim(),
        indicatif,
        telephone: tel.trim(),
        linkedin: linkedin.trim(),
      });
    } catch (e) {
      // On continue même si le save échoue — l'entretien peut commencer
    } finally {
      navigate('/candidats', { state: { job_description: offre.titre || offre.titre_optimise || 'Poste non spécifié' } });
    }
  };

  const fieldLabel = {
    fontFamily:'DM Mono,monospace', fontSize:10, color:'var(--muted)',
    letterSpacing:2, textTransform:'uppercase', marginBottom:8, display:'block',
  };
  const fieldInput = (hasError) => ({
    width:'100%', background:'transparent', border:'none',
    borderBottom:`1px solid ${hasError ? 'var(--error)' : 'var(--border)'}`,
    padding:'10px 0', fontSize:14, color:'var(--text)',
    fontFamily:'DM Sans,sans-serif', outline:'none',
  });
  const errMsg = {
    fontSize:11, color:'var(--error)', fontFamily:'DM Mono,monospace',
    letterSpacing:0.5, marginTop:4, display:'block',
  };

  return (
    <div style={{ background:'var(--bg)', color:'var(--text)', fontFamily:'DM Sans,sans-serif', minHeight:'100vh' }}>

      {/* NAV */}
      <nav style={{ position:'sticky', top:0, zIndex:100, display:'flex', alignItems:'center', justifyContent:'space-between', padding: isMobile ? '0 20px' : '0 48px', height:60, background:'var(--nav-bg)', borderBottom:'1px solid var(--border)' }}>
        <NavLogo/>
        {!isMobile && (
          <div style={{ fontFamily:'DM Mono,monospace', fontSize:11, color:'var(--muted)', letterSpacing:1 }}>
            REF — <span style={{ color:'var(--accent2)' }}>{OFFRE.ref}</span>
          </div>
        )}
        <span onClick={() => navigate('/offres')} style={{ display:'inline-flex', alignItems:'center', gap:6, color:'var(--muted)', fontSize:12, fontFamily:'DM Mono,monospace', cursor:'pointer', letterSpacing:0.5 }}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5M12 5l-7 7 7 7"/></svg>
          {isMobile ? '' : 'Toutes les offres'}
        </span>
      </nav>

      {/* LAYOUT */}
      <div style={{ display:'flex', flexDirection: isMobile ? 'column' : 'row', minHeight:'calc(100vh - 60px)' }}>

        {/* BRIEF */}
        <div style={{
          width: isMobile ? '100%' : '55%',
          borderRight: isMobile ? 'none' : '1px solid var(--border)',
          borderBottom: isMobile ? '1px solid var(--border)' : 'none',
          padding: isMobile ? '28px 20px' : 48,
          background:'var(--bg)',
          overflowY:'auto'
        }}>
          <div style={{ fontFamily:'DM Mono,monospace', fontSize:10, color:'var(--muted)', letterSpacing:2, textTransform:'uppercase', marginBottom:8 }}>
            Mission TOS
          </div>
          <h1 style={{ fontFamily:'Syne,sans-serif', fontSize: isMobile ? 'clamp(24px,7vw,36px)' : 'clamp(28px,3.5vw,44px)', fontWeight:800, lineHeight:1.05, letterSpacing:-1.5, marginBottom:24 }}>
            {(offre.titre || offre.titre_optimise || OFFRE.titre).split(' ').map((w,i) => i === 1
              ? <span key={i} style={{ color:'var(--accent)' }}>{w} </span>
              : w + ' '
            )}
          </h1>

          <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:1, background:'var(--border)', border:'1px solid var(--border)', marginBottom:28 }}>
            {[
              { label:'Rémunération', value: offre.salaire || OFFRE.salaire, color:'var(--accent2)' },
              { label:'Modalité',     value: offre.modalite || 'Télétravail' },
              { label:'Contrat',      value: offre.contrat || 'CDI' },
            ].map(c => (
              <div key={c.label} style={{ background:'var(--bg2)', padding: isMobile ? '12px 10px' : '16px 18px' }}>
                <div style={{ fontFamily:'DM Mono,monospace', fontSize:9, color:'var(--muted)', letterSpacing:2, textTransform:'uppercase', marginBottom:4 }}>{c.label}</div>
                <div style={{ fontFamily:'Syne,sans-serif', fontSize: isMobile ? 12 : 14, fontWeight:700, color:c.color || 'var(--text)' }}>{c.value}</div>
              </div>
            ))}
          </div>

          {[
            { title:'Mission', content:
              <p style={{ fontSize: isMobile ? 14 : 15, color:'var(--text)', lineHeight:1.8 }}>
                {offre.annonce_complete || offre.description || "Nous recherchons un profil expérimenté pour rejoindre notre équipe et contribuer à notre croissance."}
              </p>
            },
            ...(offre.competences ? [{ title:'Compétences requises', content:
              <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
                {offre.competences.split('\n').filter(Boolean).map((r,i) => (
                  <div key={i} style={{ display:'flex', gap:10, fontSize: isMobile ? 14 : 15, color:'var(--text)', lineHeight:1.6 }}>
                    <span style={{ color:'var(--accent2)', fontWeight:700, flexShrink:0 }}>›</span>{r}
                  </div>
                ))}
              </div>
            }] : [{ title:'Responsabilités', content:
              <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
                {OFFRE.responsabilites.map((r,i) => (
                  <div key={i} style={{ display:'flex', gap:10, fontSize: isMobile ? 14 : 15, color:'var(--text)', lineHeight:1.6 }}>
                    <span style={{ color:'var(--accent2)', fontWeight:700, flexShrink:0 }}>›</span>{r}
                  </div>
                ))}
              </div>
            }]),
            ...(!offre.competences ? [{ title:'Profil recherché', content:
              <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
                {OFFRE.profil.map((r,i) => (
                  <div key={i} style={{ display:'flex', gap:10, fontSize: isMobile ? 14 : 15, color:'var(--text)', lineHeight:1.6 }}>
                    <span style={{ color:'var(--accent2)', fontWeight:700, flexShrink:0 }}>›</span>{r}
                  </div>
                ))}
              </div>
            }] : []),
            { title: offre.tags && offre.tags.length > 0 ? 'Tags' : 'Stack technique', content:
              <div style={{ display:'flex', flexWrap:'wrap', gap:8 }}>
                {(offre.tags && offre.tags.length > 0 ? offre.tags : OFFRE.stack).map(t => (
                  <span key={t} style={{ fontFamily:'DM Mono,monospace', fontSize: isMobile ? 11 : 13, color:'var(--accent2)', border:'1px solid var(--accent2-20)', background:'var(--accent2-04)', padding:'4px 10px' }}>{t}</span>
                ))}
              </div>
            },
          ].map(sec => (
            <div key={sec.title} style={{ marginBottom:24 }}>
              <div style={{ fontFamily:'DM Mono,monospace', fontSize:10, color:'var(--accent)', letterSpacing:2.5, textTransform:'uppercase', marginBottom:12, display:'flex', alignItems:'center', gap:10 }}>
                {sec.title}
                <span style={{ flex:1, height:1, background:'var(--border)', display:'block' }}/>
              </div>
              {sec.content}
            </div>
          ))}
        </div>

        {/* FORMULAIRE */}
        <div style={{ width: isMobile ? '100%' : '45%', padding: isMobile ? '28px 20px' : 48, overflowY:'auto' }}>

          <div style={{ display:'flex', alignItems:'center', gap:20, marginBottom:32 }}>
            <div style={{ fontFamily:'Syne,sans-serif', fontSize: isMobile ? 48 : 64, fontWeight:800, lineHeight:1, color:'var(--text)' }}>01</div>
            <div>
              <div style={{ fontFamily:'DM Mono,monospace', fontSize:10, color:'var(--muted)', letterSpacing:2, textTransform:'uppercase', marginBottom:4 }}>Étape 1 sur 2</div>
              <div style={{ fontFamily:'Syne,sans-serif', fontSize: isMobile ? 18 : 20, fontWeight:800 }}>Votre profil</div>
            </div>
          </div>

          <div style={{ display:'flex', gap:4, marginBottom:32 }}>
            <div style={{ flex:1, height:2, background:'var(--accent)' }}/>
            <div style={{ flex:1, height:2, background:'var(--accent-10)' }}/>
          </div>

          <div style={{ display:'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: isMobile ? 0 : 24 }}>
            <div style={{ marginBottom:20 }}>
              <label style={fieldLabel}>Prénom <span style={{ color:'var(--accent)' }}>*</span></label>
              <input style={fieldInput(errors.prenom)} value={prenom} onChange={e => setPrenom(e.target.value.replace(LETTRES_REGEX, ''))} placeholder="Jean"/>
              {errors.prenom && <span style={errMsg}>{errors.prenom}</span>}
            </div>
            <div style={{ marginBottom:20 }}>
              <label style={fieldLabel}>Nom <span style={{ color:'var(--accent)' }}>*</span></label>
              <input style={fieldInput(errors.nom)} value={nom} onChange={e => setNom(e.target.value.replace(LETTRES_REGEX, ''))} placeholder="Dupont"/>
              {errors.nom && <span style={errMsg}>{errors.nom}</span>}
            </div>
          </div>

          <div style={{ marginBottom:20 }}>
            <label style={fieldLabel}>Email <span style={{ color:'var(--accent)' }}>*</span></label>
            <input style={fieldInput(errors.email)} value={email} onChange={e => setEmail(e.target.value)} type="email" placeholder="jean.dupont@email.com"/>
            {errors.email && <span style={errMsg}>{errors.email}</span>}
          </div>

          <div style={{ marginBottom:20 }}>
            <label style={fieldLabel}>Téléphone <span style={{ color:'var(--accent)' }}>*</span></label>
            <div style={{ display:'flex', gap:8, alignItems:'flex-end' }}>
              <select
                value={indicatif}
                onChange={e => setIndicatif(e.target.value)}
                style={{ background:'var(--bg2)', border:'none', borderBottom:'1px solid var(--border)', padding:'10px 6px', fontSize: isMobile ? 12 : 13, color:'var(--text)', fontFamily:'DM Mono,monospace', outline:'none', cursor:'pointer', flexShrink:0, maxWidth: isMobile ? 150 : 'none' }}
              >
                {INDICATIFS.map(i => (
                  <option key={i.code} value={i.code}>{i.code} {i.pays}</option>
                ))}
              </select>
              <input
                style={{ ...fieldInput(errors.tel), flex:1 }}
                value={tel}
                onChange={e => setTel(e.target.value.replace(TEL_REGEX, ''))}
                placeholder="06 123 45 67"
                maxLength={15}
              />
            </div>
            {errors.tel && <span style={errMsg}>{errors.tel}</span>}
          </div>

          <div style={{ marginBottom:36 }}>
            <label style={fieldLabel}>LinkedIn</label>
            <input style={fieldInput(errors.linkedin)} value={linkedin} onChange={e => setLinkedin(e.target.value)} placeholder="https://linkedin.com/in/votre-profil"/>
            {errors.linkedin && <span style={errMsg}>{errors.linkedin}</span>}
          </div>

          <button
            onClick={handleSubmit}
            style={{ width:'100%', background:'var(--accent)', color:'#fff', border:'none', padding:'14px 24px', fontFamily:'DM Mono,monospace', fontSize:12, letterSpacing:2, textTransform:'uppercase', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:10 }}
          >
            Continuer vers le CV <IconArrow/>
          </button>

        </div>
      </div>
    </div>
  );
}